import { render, staticRenderFns } from "./CardsContainerNew.vue?vue&type=template&id=515c8393&scoped=true"
import script from "./CardsContainerNew.vue?vue&type=script&lang=ts"
export * from "./CardsContainerNew.vue?vue&type=script&lang=ts"
import style0 from "./CardsContainerNew.vue?vue&type=style&index=0&id=515c8393&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c8393",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515c8393')) {
      api.createRecord('515c8393', component.options)
    } else {
      api.reload('515c8393', component.options)
    }
    module.hot.accept("./CardsContainerNew.vue?vue&type=template&id=515c8393&scoped=true", function () {
      api.rerender('515c8393', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardsContainerNew.vue"
export default component.exports